import constants from "../constants";
import { spaceships } from "../web3/SFM-SpaceshipConstants";
export const SpaceShipsData = [
  {
    name: 'ELYTHUM SHIP',
    type: 'Spaceship',
    description: constants.Elythum_ship,
    price:"$150,00",
    image:"assets/img/product/ELYSIUM SHIP 400x500px.gif",
    category:spaceships.elythumShip
  },
  {
    name: 'JOY‑CON CONTROLLERS',
    type: 'Spaceship',
    description: constants.Joy_Con,
    price:"$25,00",
    image:"assets/img/product/Joy Con 400 x 500.gif",
    category:spaceships.joyCon
  },
  { 
    name: 'Shape Switch',
    type: 'Spaceship',
    description: constants.Shape_Switch,
    price:"$75,00",
    image:"assets/img/product/Nintindo Switch 400 x 500.gif",
    category:spaceships.shapeSwitch
  }
];
